<div [class]="small ? 'small' : 'big'" *ngFor="let sleepDiaries of sleepDiariesByDay | keyvalue, let i = index">
    <p [innerHTML]="sleepDiaries.key  | amDateFormat: ('sleepDiary.week.sleepWindowShiftWorkDate' | translate)"></p>
    <app-sleep-diary-gantt-chart [sleepDiaries]="sleepDiaries.value"
                                 [workingShift]="workingShiftsByDay.get(sleepDiaries.key)"
                                 [showXAxis]="true"
                                 [xAxisSplit]="10"
                                 [small]="small"></app-sleep-diary-gantt-chart>
</div>
